import React from "react"
import ReactDOM from "react-dom/client"
import Providers from "@/app/providers"
import "@/app/globals.css"
import { AppRouter } from "@/lib/router/AppRouter"

function App() {
  return (
    <Providers>
      <AppRouter />
    </Providers>
  )
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
